import {STATISTICS_INIT_STATE, SET_STATISTICS} from "./types";

export const statisticsReducer = (state = STATISTICS_INIT_STATE, action) => {
    switch (action.type) {
        case SET_STATISTICS:
            return action.payload;
        default:
            return state
    }
}